import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import app from "lib/app";
import me from "models/me";
import theme, { themeOptions } from "styles/theme";
import "./material-ui-patch";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import SiteNav from "components/site-nav";
import { SiteHeader } from "components/page/site-header";
import { $, insertRule, merge, presets } from "glamor";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import {
    cartBulkRemove,
    cartFetch,
    cartItemAdd,
    cartItemRemove,
    cartItemsFetch,
    cartRetoggle,
    saveCartRedirectAfterSubmit,
    syncFromCart,
} from "actions/cart";
import {
    activeBrandClear,
    fetchCompanyAndSetViewAs,
    activeBrandSet,
    activeCompanyClear,
    activeCurrencySet,
    fetchStartOrderCompanies,
    setShowTerms,
    setUserType,
    setViewAs,
    toggleHideMsrp,
    toggleHideWholesale,
    toggleViewAsGuest,
} from "actions/scope";
import { resetProducts } from "actions/products";
import {
    fetchCustomizationProductById,
    resetLineItemEdit,
    resetBulkCustomizationModal,
    resetProofWarning,
} from "actions/customization-actions";
import {
    add as snackbarAdd,
    clear as clearSnackbar,
    remove as removeSnackbar,
    snackbarRemove,
} from "actions/snackbars";
import {
    legacyLoaded,
    pageLeave,
    setViewport,
    toggleLoginDialog,
    toggleWorkingOrderLoadingDialog,
    updateNavState,
} from "actions/app";
import { activeListAdd, activeListFetchEntries, activeListRemoveAndDelete, activeListSet } from "actions/active-list";
import { openRetailerProfile } from "actions/retailer-profile-form";
import { makeAccessRequest } from "actions/legacy-retailers";
import classNames from "classnames";
import { APP_MENU_STATE_PINNED } from "constants/menu";
import { CartRedirect } from "constants/brand-settings";
import {
    IFRAME_REDUX_ACTION,
    SAVE_CUSTOM_GRID_VIEW,
    SHIPMENT_REVIEW_IFRAME_MESSAGE,
    WORKING_ORDER_SNACKBAR_ID,
} from "constants/cart";
import Snackbars from "components/snackbars";
import LoginDialog from "components/login/login-dialog";
import WorkingOrderLoadingDialog from "components/working-order-loading-dialog";
import AppLoader from "components/AppLoader";
import { trackShopBrandClick } from "actions/brand-profile";
import { getPendingCount } from "actions/connection-requests";
import siteConfig from "site-config";
import Ajax from "lib/ajax";
import Model from "lib/model";
import moment from "moment";
import {
    requestForgotPassword,
    resetState as resetLoginState,
    trackLoginArticles,
    trackLoginRegistration,
    trackLoginVideo,
} from "actions/authentication";
import InventoryArrivingModal from "containers/inventory-arriving-modal";
import { AnalyticsClient } from "@nuorder/analytics-aggregator";
import Globalize from "globalize";
import { Zendesk } from "components/zendesk";
import Intercom from "components/intercom";

import { getCancelledOrdersCount, getCancelledStylesCount } from "actions/cancelled-styles-actions";
import CheckForUpdates from "./CheckForUpdates";
import Alert from "components/dialog/alert";
import ConfirmDialog from "components/dialog/confirm";
import { ModalTitle } from "components/payments/dialog-title";
import { PaymentFailureContent } from "components/payments/payment-failure-content";
import { PaymentSuccessContent } from "components/payments/payment-success-content";
import { AppProvider } from "../hooks/useApp";
import { ReactQueryConfigProvider } from "react-query";
import { WhatIsDeployed } from "./develop/what-is-deployed";
import * as AgGridEnterprise from "ag-grid-enterprise";
import { TermsPage } from "components/admin/terms-and-conditions";
import { ProductCustomizationModal } from "components/customization-modal/customization-modal";
import { updateLdFlags } from "../actions/ld-flags-actions";
import {
    customizationSelectionValueMap,
    customizationSelectionDefaultValueMap,
    validCustomizationSelections,
} from "constants/product-customizations/customization";
// Per Stripe docs, we want to load Stripe lib across entire app for better fraud detection.
// Also probably other sneaky things.
import { loadStripe } from "@stripe/stripe-js";
import { CustomizationMissingCompanyWarningDialog } from "./customization-modal/customizations-modal-warning-dialog";
import { setCurrentItem } from "actions/item";
import { trackChurnZeroEvent } from "../lib/churn-zero";
import { LSIDIdentityObserver } from "components/identity-observer";
import { ProductCustomizationTemplateFontLoader } from "./customization-modal/product-customization-template-font-loader";
import { AccessControlErrorModal } from "components/access-control-error-modal";
import gridActions, { createCustomGridView } from "actions/cart-grid-view";
import { BulkCustomizationModal } from "./customization-modal/bulk-customization-modal/bulk-customization-modal";
import { fetchSmartOrders } from "../models/new/smart-orders";
import { Spinner } from "@nuorder/components";
import { transitGridSettings } from "../containers/legacy-cart/helpers";
import { gtm, RREventType } from "helpers/gtm";
import { openWorkingOrder } from "actions/working-order-state";
import { addLineItem } from "../actions/working-order/line-items";
import { showLoader } from "../actions/loader";
import ProofRemoveWarningModal from "./order/line-item/customizations/proof-remove-warning-modal";
import {
    isSideInsightsPanelEnabledAndOpenInGalleryPage,
    shouldDisplayInsightsToggleButton,
} from "../reducers/insights-reducer";
import { isMobilePage } from "helpers/url/page";
import AsyncEventTrackerWrapperContainer from "containers/async-event-tracker/async-event-tracker-container";

import { tx, SourceStringPolicy } from "@transifex/native";
import { getTransifexLocaleCode, isSupportedLocale } from "helpers/transifex/helpers.ts";
import { MARKETPLACE } from "constants/navigation";
import MuiThemeProviderBase from "./material-ui-themeProvider-base";

// MFE SETUP

AgGridEnterprise.LicenseManager.setLicenseKey(siteConfig.AG_GRID_LICENSE_KEY);

const queryConfig = {
    queries: {
        refetchOnWindowFocus: false,
    },
};

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

window.nuorderUserSetAttribute = (key, value, callback) => {
    Ajax.sync("patch", new Model(), {
        url: "/user/update/profile",
        json: { [key]: value },
        success: (userData) => {
            userData.authStatus = me.authStatus;
            me.set(userData);
            if (callback) {
                callback(null);
            }
        },
        error: (err) => {
            if (callback) {
                callback(err);
            }
        },
    });
};

class Main extends PureComponent {
    static childContextTypes = {
        me: PropTypes.object.isRequired,
        legacyLoaded: PropTypes.bool.isRequired,
        viewport: PropTypes.oneOf(["hd", "desktop", "tablet", "phablet", "mobile"]),
        app: PropTypes.object.isRequired,
        viewAs: PropTypes.object,
        scope: PropTypes.object.isRequired,
        searchTerm: PropTypes.string,
        stripe: PropTypes.object,
        flags: PropTypes.object,
    };

    static contextTypes = {
        store: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired,
    };

    static propTypes = {
        legacyLoaded: PropTypes.bool.isRequired,
        router: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        flags: PropTypes.object.isRequired,
        onLdFlagsChanged: PropTypes.func.isRequired,
    };

    mainStyles = merge(
        {
            paddingLeft: `${theme.nav.iconWidth}px`,
            background: "white",
            minHeight: "100%",
            height: "100%",
            paddingTop: "64px",
        },
        $(".hideHeader", {
            paddingTop: "0px",
        }),
        $(".hideNav", {
            paddingLeft: "0px",
        }),
        $(" > main", {
            height: "100%",
            transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1)",
        }),
        $(" > main.sidePanelOpen", {
            paddingRight: theme.sidebar.width + "px",
        }),
        $(".isMenuPinned &", { paddingLeft: `${theme.nav.iconAndTextWidth}px` }),
        $(".isMobile &", { paddingLeft: "0px" }),
    );

    rootStyles = merge(
        $(" .toastContentLoader", {
            width: "40px",
            position: "relative",
            background: "transparent",
        }),
    );

    overflowForTouch = merge({
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
    });

    nuAnalytics;

    constructor(props) {
        super(props);
        this.state = {
            legacyLoaded: false,
            viewAs: undefined,
            loginDialogOpen: false,
            loginRedirect: "",
            tryOpenWorkingOrder: false,
            paymentNotification: null,
            stripe: null,
            isWOUpdating: false,
        };

        this.LSIDIdentityObserver = new LSIDIdentityObserver();

        // Insert legacy icons for payment in orders
        // This should be removed when orders is updated to use svgs
        insertRule(`@font-face {
            font-family: "icon";
            src: url('${siteConfig.assetPath}/fonts/icons-0.0.0.eot');
            src: url('${siteConfig.assetPath}/fonts/icons-0.0.0.eot?#iefix') format('eot'), url('${siteConfig.assetPath}/fonts/icons-0.0.0.woff') format('woff'), url('${siteConfig.assetPath}/fonts/icons-0.0.0.ttf') format('truetype'), url('${siteConfig.assetPath}/fonts/icons-0.0.0.svg#icons-0.0.0') format('svg');
            font-weight: normal;
            font-style: normal;
        }`);

        this.nuAnalytics = new AnalyticsClient({ goEndpoint: siteConfig.goAPI });
        this.initStripe();

        if (props.flags.isTransifexEnabledNu68053 && isSupportedLocale(me.locale)) {
            // SETUP TRANSIFEX
            tx.init({
                token: siteConfig?.TRANSIFEX_PUBLIC_PROJECT_TOKEN,
                missingPolicy: new SourceStringPolicy(),
            });

            tx.setCurrentLocale(getTransifexLocaleCode(me.locale)).catch((e) => {
                // eslint-disable-next-line no-console
                console.log("Error setting Transifex locale", e);
            });
        }
    }

    getChildContext() {
        return {
            app: app,
            legacyLoaded: this.props.legacyLoaded,
            me: me,
            scope: this.props.scope,
            searchTerm: "",
            viewAs: this.props.viewAs,
            viewport: this.props.viewport,
            stripe: this.state.stripe,
            flags: this.props.flags,
        };
    }

    UNSAFE_componentWillMount() {
        me.store = this.context.store; // redux
        const { scope, onSetUserType } = this.props;

        app.on("legacy:wholesale-loaded", this.handleLegacyLoaded, this);
        app.on("legacy:wholesale-unloaded", this.handleLegacyUnloaded, this);
        app.on("legacy:iframe-click", this.handleLegacyClick, this);
        app.on("legacy:unauthorized", this.handleLegacyUnauthorized, this);
        app.on("legacy:goto", this.handleRoute, this);
        app.on("legacy:checkForRecursiveIframe", this.handleReload, this);
        app.on("legacy:brand-updated", this.handleLegacyBrandChange, this);
        app.on("legacy:promotion-added", this.handlePromotionAdded, this);
        app.on("legacy:promotion-updated", this.handlePromotionUpdated, this);
        app.on("legacy:payment-notification", this.handlePaymentNotification, this);
        app.on("legacy:payment-error-notification", this.handlePaymentErrorNotification, this);
        app.on("legacy:payment-success-notification", this.handlePaymentSuccessNotification, this);
        app.on("legacy:payment-challenge-error-notification", this.handlePaymentChallengeErrorNotification, this);
        app.on("legacy:payment-challenge-success-notification", this.handlePaymentChallengeSuccessNotification, this);
        app.on("legacy:add-snackbar-message", this.handleLegacySnackbar, this);
        app.on("legacy:track", this.handleTrackEvent, this);
        app.on("legacy:updating-working-order", this.handleUpdatingWorkingOrder, this);
        app.on("legacy:churn-zero-track", this.churnZeroTrack, this);
        app.on("legacy:google-tag-manager", this.handleGoogleTagManager, this);
        app.on("legacy:brand-google-analytics", this.handleGoogleAnalyticsEvent, this);
        app.on("legacy:load-in-cart-iframe", this.loadInCartIFrame, this);
        app.on("legacy:update-in-cart-iframe-data", this.updateInCartIFrame, this);
        app.on("legacy:clear-cart-iframe", this.clearCartIframe, this);
        app.on("legacy:request-feature-flags", this.handleSendFeatureFlagsToLegacy, this);
        app.on(`legacy:${SHIPMENT_REVIEW_IFRAME_MESSAGE}`, this.handleShipmentReviewIframeMessage, this);

        me.on("change:authStatus", this.handleLoginChange, this);
        me.on("change:activeBrand", this.handleBrandChange, this);
        onSetUserType(me.account_type);
        if (window.matchMedia) {
            this.mediaQueries = Object.keys(presets).map((key) => {
                const mediaQuery = window.matchMedia(presets[key]);
                mediaQuery.addListener(this.updateViewPort.bind(this));
                return { key, query: mediaQuery };
            });
        }

        this.onPageChange();

        if (scope.brand && scope.brand._id) {
            this.handleBrandChange(scope.brand);
        }
        me.handleBrandChange(); // Also identify user

        global.analytics.on("page", (event, properties, { path }) => {
            this.nuAnalytics.pageView({
                t: document.title,
                l: document.URL,
                p: path,
            });
        });

        global.analytics.on("track", (event, properties) => {
            if (properties) {
                const { nuAnalyticsFn, nuAnalyticsParams } = properties;
                if (nuAnalyticsFn) {
                    const params = Array.isArray(nuAnalyticsParams) ? nuAnalyticsParams : [nuAnalyticsParams];
                    this.nuAnalytics[nuAnalyticsFn](...params);
                }
            }
        });
    }

    componentWillUnmount() {
        app.off("legacy:wholesale-loaded", this.handleLegacyLoaded, this);
        app.off("legacy:wholesale-unloaded", this.handleLegacyUnloaded, this);
        app.off("legacy:iframe-click", this.handleLegacyClick, this);
        app.off("legacy:unauthorized", this.handleLegacyUnauthorized, this);
        app.off("legacy:goto", this.handleRoute, this);
        app.off("legacy:checkForRecursiveIframe", this.handleReload, this);
        app.off("legacy:brand-updated", this.handleLegacyBrandChange, this);
        app.off("legacy:promotion-added", this.handlePromotionAdded, this);
        app.off("legacy:promotion-updated", this.handlePromotionUpdated, this);
        app.off("legacy:payment-notification", this.handlePaymentNotification, this);
        app.off("legacy:payment-error-notification", this.handlePaymentErrorNotification, this);
        app.off("legacy:payment-success-notification", this.handlePaymentSuccessNotification, this);
        app.off("legacy:add-snackbar-message", this.handleLegacySnackbar, this);
        app.off("legacy:track", this.handleTrackEvent, this);
        app.off("legacy:updating-working-order", this.handleUpdatingWorkingOrder, this);
        app.off("legacy:churn-zero-track", this.churnZeroTrack, this);
        me.off("change:authStatus", this.handleLoginChange, this);
        me.off("change:activeBrand", this.handleBrandChange, this);

        app.off("legacy:load-in-cart-iframe", this.loadInCartIFrame, this);
        app.off("legacy:update-in-cart-iframe-data", this.updateInCartIFrame, this);
        app.off("legacy:clear-cart-iframe", this.clearCartIframe, this);
        app.off("legacy:request-feature-flags", this.handleSendFeatureFlagsToLegacy, this);
        app.off(`legacy:${SHIPMENT_REVIEW_IFRAME_MESSAGE}`, this.handleShipmentReviewIframeMessage, this);
        this.LSIDIdentityObserver.identityObserverUnsubscribe();
    }

    componentDidUpdate(prevProps) {
        // This keeps the cart in a spinner state when switching active brands to prevent
        // users from clicking the cart early and triggering a working order error (WAPP-13080)
        if (
            prevProps.scope.brand &&
            this.props.scope.brand &&
            this.props.scope.brand._id !== prevProps.scope.brand._id
        ) {
            this.handleLegacyUnloaded();
            me.handleBrandChange();
            if (this.props.flags?.smartOrdersPage) {
                this.props.fetchSmartOrders();
            }
        }

        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.onPageChanged(global.location.origin + prevProps.location.pathname);

            const wasIframeApp = prevProps.location.pathname.includes("shipment-review");
            const isIframeApp = this.props.location.pathname.includes("shipment-review");
            if (wasIframeApp && !isIframeApp) {
                window.parent.postMessage({ action: "iframe_app_destroyed" }, "*");
            }
        }

        if (prevProps.flags !== this.props.flags) {
            this.onFeatureFlagsChanged(this.props.flags);
        }

        if (prevProps.flags.lsidObserver !== this.props.flags.lsidObserver) {
            const pathName = this.props.router.location.pathname;
            const mobileQueryParam = this.props.router.location.query.mobile;

            if (!this.props.flags.lsidObserver) {
                this.LSIDIdentityObserver.identityObserverUnsubscribe();
            } else if (this.LSIDIdentityObserver.canSubscribe(pathName, mobileQueryParam)) {
                this.LSIDIdentityObserver.subscribe();
            }
        }

        const { customizationProductId, onFetchProductById } = this.props;
        if (prevProps.customizationProductId !== customizationProductId && customizationProductId) {
            onFetchProductById(customizationProductId);
        }
    }

    componentDidMount() {
        this.onPageChanged();
        if (this.props.flags.smartOrdersPage) {
            this.props.fetchSmartOrders();
        }
        if (this.props.location.query.merchant_organization_connected === "true") {
            this.removeQueryParam("merchant_organization_connected");
            this.props.onSnackbarAdd({
                message: Globalize.formatMessage("NuORDER and Lightspeed Retail are now connected."),
            });
        }
        const isIframeApp = window.location.pathname.includes("shipment-review");
        if (window.parent && isIframeApp) {
            window.parent.postMessage({ action: "iframe_app_launched" }, "*");
        }
        this.onFeatureFlagsChanged(this.props.flags);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.pathname !== this.props.location.pathname) {
            this.onPageChange(nextProps);

            if (
                nextProps.location.pathname.split("/").length <= 2 ||
                (this.props.location.pathname.indexOf(nextProps.location.pathname) !== -1 &&
                    nextProps.location.pathname.indexOf(this.props.location.pathname) !== -1)
            ) {
                this.props.onPageLeave();
            }
        }
    }

    handleSendFeatureFlagsToLegacy() {
        app.legacy.sendMessage({ action: "launch-darkly-flags", data: { ...this.props.flags } });
    }

    onFeatureFlagsChanged = (flags) => {
        this.props.onLdFlagsChanged(flags);
        app.legacy.sendMessage({ action: "launch-darkly-flags", data: { ...flags } });
    };

    initStripe = async () => {
        try {
            if (siteConfig?.STRIPE_PUBLISHABLE_KEY) {
                const stripe = await loadStripe(siteConfig.STRIPE_PUBLISHABLE_KEY);
                this.setState({ stripe });
            }
        } catch (error) {
            // we should not throw errors if unable to instantiate stripe.
            // all stripe usages might validate the existance of the instance
            // and handle the customer experience appropriately
        }
    };

    handleSetViewAs = (company) => {
        if (company) {
            this.props.onSetViewAsCompany(company);
        } else {
            this.props.onClearCompany();
            this.props.onSetViewAs(company);
        }
    };

    updateViewPort() {
        let viewport = "mobile";
        this.mediaQueries.forEach((mediaQuery) => {
            if (mediaQuery.query.matches) {
                viewport = mediaQuery.key;
            }
        });

        this.props.onSetViewport(viewport);
    }

    removeQueryParam(param) {
        const searchParams = new URLSearchParams(window.location.search);

        searchParams.delete(param);

        const newSearch = searchParams.toString();

        browserHistory.replace({
            pathname: window.location.pathname,
            search: newSearch ? `?${newSearch}` : "",
        });
    }

    handlePromotionAdded() {
        this.props.onSnackbarAdd({
            message: Globalize.formatMessage("New Promotional Product Added!"),
            options: {
                bodyStyle: {
                    backgroundColor: themeOptions.palette.primary1Color,
                },
                style: {
                    zIndex: 10000000000,
                },
            },
        });
    }

    handlePromotionUpdated() {
        this.props.onSnackbarAdd({
            message: Globalize.formatMessage("You received another promotional item!"),
            options: {
                bodyStyle: {
                    backgroundColor: themeOptions.palette.primary1Color,
                },
                style: {
                    zIndex: 10000000000,
                },
            },
        });
    }

    handleLegacySnackbar({ message }) {
        this.props.onSnackbarAdd({
            message: message,
            options: {
                bodyStyle: {
                    backgroundColor: themeOptions.palette.primary1Color,
                },
                style: {
                    zIndex: 10000000000,
                },
            },
        });
    }

    handleUpdatingWorkingOrder({ payload }) {
        this.setState({ isWOUpdating: payload.updating });
    }

    onPageChange(nextProps) {
        if (nextProps && nextProps.location.pathname.endsWith("/cart")) {
            const { scope, location, onSaveCartEntryProint } = this.props;
            const redirectTo = scope.brand.getPreference("after_ordering_redirect_to");

            if (redirectTo === CartRedirect.ENTRYPOINT) {
                onSaveCartEntryProint(location.pathname);
            }
        } else if (
            this.props?.location?.pathname !== nextProps?.location?.pathname &&
            this.props?.location?.pathname?.endsWith("/cart")
        ) {
            this.props.onRemoveSnackbar(WORKING_ORDER_SNACKBAR_ID);
        }
    }

    onPageChanged(referrer) {
        const { router, scope, onGetPendingCount, onGetCancelledCount, onGetCancelledStylesCount } = this.props;
        const lastRoute = this.props.routes[this.props.routes.length - 1];
        if (me.isSignedIn() && scope.brand && scope.brand._id && !scope.site) {
            let category = capitalizeFirstLetter(lastRoute.parentSection || lastRoute.title || "Wholesale");
            if (category === "Find New Accounts") {
                category = "Marketplace";
            }

            let groupId = scope.brand._id;
            if (me.account_type !== "brand") {
                groupId = `${groupId}-${me.account_type}`;
            }

            const pageProps = { groupId, GroupID: scope.brand._id };
            if (referrer) {
                pageProps.referrer = referrer;
            }

            let pathname = router.location.pathname;
            Object.keys(router.params || {}).forEach((key) => {
                pathname = pathname.replace(router.params[key], `:${key}`);
            });
            pageProps.path = pathname;
            pageProps.url = document.location.protocol + "//" + document.location.hostname + pathname;
            pageProps.originalUrl = document.location.href;

            if (pageProps.path === "/brand/:brand/admin/brand/vp/:component") {
                category = "Admin";
            }

            if (category === "Admin") {
                lastRoute.title = this.props.params.component;
            }

            global.analytics.page(category, lastRoute.title, pageProps);
            if (
                category !== "Admin" &&
                scope.brand._id &&
                (lastRoute.title || "").toLowerCase().indexOf("order") === 0
            ) {
                // HACK
                me.trackAction(`Entered ${lastRoute.title} Page`, {
                    category: "Wholesale",
                });
            }
            if (me.hasPermission("can_manage_connection_requests")) {
                onGetPendingCount();
            }

            if (me.hasPermission("manage_cancelled_styles")) {
                onGetCancelledCount(scope.brand._id);
                onGetCancelledStylesCount(scope.brand._id);
            }
            if (gtm.allowPageView(pageProps.originalUrl)) {
                gtm.emit(
                    gtm.events.pageView({
                        page_location: pageProps.originalUrl,
                        page_title: gtm.fetchPageTitle(pageProps.originalUrl),
                        send_to: gtm.groups.Brand,
                    }),
                );
            }
        }
    }

    handleLoginChange() {
        this.props.onClearCompany();
        this.props.onSetViewAs();
        if (!me.isSignedIn()) {
            this.props.onClearBrand();
        }
    }

    /**
     * "handleLegacyBrandChange" calls to update some properties of the brand
     * parameter brand is coming from API without warehouses(inside settings) data which we have stored in scope
     * updated the brand with warehouses to use in company details
     */
    handleLegacyBrandChange(brand = {}) {
        const { scope } = this.props;
        if (scope.brand && brand._id === scope.brand._id) {
            // TODO: wrap settings into an immutable collection, now settings is a plain object
            const updatedBrand = scope.brand
                .set("name", brand.name)
                .set("active", brand.active)
                .set("settings", {
                    ...brand.settings,
                    warehouses: scope.brand.settings.warehouses,
                });
            this.props.onSetBrand(updatedBrand.toJSON());
        }
    }

    handleBrandChange(brand = {}) {
        const { scope } = this.props;

        this.props.onSetBrand(brand._id ? brand.toJSON() : null);
        if (me.isGuestBuyer() && scope.brand && scope.brand._id && scope.brand.hasPreference("allow_guest_buyers")) {
            this.props.onToggleViewAsGuest();
        }
    }

    handleLegacyLoaded() {
        this.props.onLegacyLoaded(true);
    }

    handleTrackEvent({ props }) {
        me.trackAction(props.event, props.data ?? {});
    }

    handleMarketplaceGTM(props) {
        const hasEvent = [
            "gtm-marketplace-clicked-new-retailer-this-week",
            "gtm-marketplace-view-search-result",
            "gtm-marketplace-search-location",
            "gtm-marketplace-search",
            "gtm-marketplace-clicked-retailer-view-details",
            "gtm-marketplace-clicked-connect-to-retailer-button",
            "gtm-marketplace-clicked-retailer-connect-button",
        ].includes(props.event);

        if (hasEvent) {
            gtm.emit(
                gtm.events.marketPlace({
                    event: props.event,
                    me,
                    scope: this.props.scope,
                    payload: {
                        searchValue: props.searchValue,
                        category: props.category,
                        subCategories: props.subCategories,
                        location: props.location,
                        brands: props.brands,
                        retailer: props.retailer,
                        company: props.company,
                    },
                }),
            );
        }
    }

    handleGoogleTagManager({ props }) {
        if (Object.values(RREventType).includes(props?.event)) {
            gtm.emit(
                gtm.events.rr({
                    event: props?.event,
                    orderId: props?.orderId,
                    orderNumber: props?.orderNumber,
                    buyerId: props?.buyerId,
                    brandId: props?.brandId,
                    companyId: props?.companyId,
                    userId: props?.userId,
                    send_to: gtm.groups.B2B,
                }),
            );
        }

        this.handleMarketplaceGTM(props);
    }

    handleGoogleAnalyticsEvent({ props }) {
        gtm.emit(gtm.events.backendBrandEvent(props));
    }

    churnZeroTrack({ props }) {
        trackChurnZeroEvent(props);
    }

    handleLegacyUnloaded() {
        this.props.onLegacyLoaded(false);
        this.props.onToggleWorkingOrderLoadingDialog(false);
    }

    handleReload() {
        // this page can be loaded in an iFrame to show the PSD2 challenge that can be redirected to a different
        // location, depending on the gateway decision.
        const isExternalChallengeRedirect = window.sessionStorage.getItem("loadedPaymentChallenge");
        const circuitBreaker = window.sessionStorage.getItem("lastForcedRefresh"); // prevent infinite loops

        if (
            (!circuitBreaker || moment.utc(circuitBreaker).add("2", "minutes").isBefore(moment.utc())) &&
            !isExternalChallengeRedirect
        ) {
            window.sessionStorage.setItem("lastForcedRefresh", moment.utc().toISOString());
            window.location.reload();
        }
    }

    handleLegacyUnauthorized(eventData) {
        if (eventData.forceLogout) {
            me.logout(true);
            return;
        }
        const location = this.props.location;
        let searchParams = location.search || "";
        // remove trailing '&'
        searchParams = searchParams.endsWith("&") ? searchParams.substring(0, searchParams.length - 1) : searchParams;

        const shouldRedirectToWO = eventData.origin === "WorkingOrder";
        if (shouldRedirectToWO) {
            searchParams = searchParams ? `${searchParams}&wo=true` : "?wo=true";
        }

        const redirectAfterLogin = location.pathname + searchParams;
        this.props.onToggleLoginDialog(true, redirectAfterLogin);
    }

    handleRoute(data) {
        if (data.force) {
            window.location = data.href;
        } else {
            this.navigate(data.href);
        }
    }

    toggleClass(className, isOn) {
        if (isOn) {
            document.body.classList.add(className);
        } else {
            document.body.classList.remove(className);
        }
    }

    handlePaymentNotification(data) {
        this.setState({ paymentNotification: { ...data } });
    }

    handleClosePaymentNotification = () => {
        this.setState({ paymentNotification: null });
    };

    handlePaymentErrorNotification(data) {
        this.setState({ paymentErrorNotification: { ...data } });
    }

    handleClosePaymentErrorNotification = () => {
        this.setState({ paymentErrorNotification: null });
    };

    handlePaymentSuccessNotification(data) {
        this.setState({ paymentSuccessNotification: { ...data } });
    }

    handleClosePaymentSuccessNotification = () => {
        this.setState({ paymentSuccessNotification: null });
    };

    handleRedirectToForgotPassword = () => {
        this.props.onToggleLoginDialog(false);
        this.props.router.push("forgot-password");
    };

    handleRedirectToFailedOrders = () => {
        const { scope } = this.props;
        const { errors } = this.state.paymentErrorNotification;
        const baseOrderNumber = errors[0].headline.split("-")[0];
        this.context.router.push(`/brand/${scope.brand._id}/orders?__search=${baseOrderNumber}`);
        this.setState({ paymentErrorNotification: null });
    };

    handleRedirectToSuccessfulOrders = () => {
        const { scope } = this.props;
        const { orders } = this.state.paymentSuccessNotification;
        const baseOrderNumber = (orders[0] || orders.models[0]).order_number.split("-")[0];
        this.context.router.push(`/brand/${scope.brand._id}/orders?__search=${baseOrderNumber}`);
        this.setState({ paymentSuccessNotification: null });
    };

    handleCloseCustomizationModal = () => {
        this.props.onResetLineItemEdit();
    };

    handleCloseProofRemoveWarning = () => {
        this.props.onResetProofWarning();
    };

    handleCloseBulkCustomizationModal = () => {
        this.props.onResetBulkCustomizationModal();
    };

    handleCustomizationSave = (map) => {
        const { onResetLineItemEdit, customizationItemId, template } = this.props;

        const customizations = validCustomizationSelections([...map.values()]);
        const updateMessage = {
            action: "update-working-order-item",
            _id: customizationItemId,
            __customizations: customizations,
            __product_customizations_template_id: template._id,
        };

        app.legacy.sendMessage(updateMessage);
        onResetLineItemEdit();
    };

    handleBulkCustomizationApply = (ids, map) => {
        const { onResetLineItemEdit } = this.props;

        const customizations = validCustomizationSelections([...map.values()]);
        app.legacy.sendMessage({
            action: "update-working-order-items",
            _ids: ids,
            updates: { __customizations: customizations },
        });
        onResetLineItemEdit();
    };

    handlePaymentChallengeErrorNotification(data) {
        this.setState({ paymentChallengeErrorNotification: { ...data } });
    }

    handleClosePaymentChallengeErrorNotification = () => {
        this.setState({ paymentChallengeErrorNotification: null });
    };

    handlePaymentChallengeSuccessNotification = (data) => {
        this.setState({ paymentChallengeSuccessNotification: { ...data } });
    };

    handleClosePaymentChallengeSuccessNotification = () => {
        this.setState({ paymentChallengeSuccessNotification: null });
    };

    handleRedirectToFailedChallengedOrders = () => {
        const { scope } = this.props;
        const { errors } = this.state.paymentChallengeErrorNotification;
        const baseOrderNumber = errors[0].headline.split("-")[0];
        this.context.router.push(`/brand/${scope.brand._id}/orders?__search=${baseOrderNumber}`);
        this.setState({ paymentChallengeErrorNotification: null });
    };

    handleRedirectToSuccessfulChallengedOrders = () => {
        const { scope } = this.props;
        const { orders } = this.state.paymentChallengeSuccessNotification;
        const baseOrderNumber = (orders[0] || orders.models[0]).order_number.split("-")[0];
        this.context.router.push(`/brand/${scope.brand._id}/orders?__search=${baseOrderNumber}`);
        this.setState({ paymentChallengeSuccessNotification: null });
    };

    get defaultCustomizationValues() {
        return customizationSelectionDefaultValueMap(this.props.customizationTemplate?.attributes ?? []);
    }

    get selectedCustomizationValues() {
        const props = this.props;

        return customizationSelectionValueMap(props.customizationSelectedValues, props.customizationTemplate);
    }

    render() {
        const { router } = this.context;
        const {
            authentication,
            activeBrand,
            activeList,
            cart,
            children,
            dragging,
            isFetching,
            requestedConnections,
            menuState,
            location,
            onActiveListAdd,
            onActiveListFetchEntries,
            onActiveListRemove,
            onCartFetch,
            onCartItemRemove,
            onCartBulkRemove,
            onCartItemsFetch,
            onClearCompany,
            onClearSnackbar,
            onClearBrand,
            onCreateBuyerProfile,
            onMakeAccessRequest,
            onRetoggleCart,
            onSnackbarAdd,
            onGalleryReset,
            onSnackbarRemove,
            onSetActiveList,
            onSetCurrency,
            onSetCurrentItem,
            onToggleViewAsGuest,
            onUpdateNavState,
            sidePanelOpen,
            isSideInsightsPanelEnabledAndOpen,
            displayInsightsToggleButton,
            touchDevice,
            viewAs,
            viewAsGuest,
            viewport,
            viewportHeight,
            loginDialogOpen,
            loginRedirect,
            tryOpenWorkingOrder,
            scope,
            onTrackShopBrandClick,
            snackbars,
            schemaIds,
            schemas,
            requestsCount,
            onSyncFromCart,
            onFetchStartOrderCompanies,
            companies,
            cartGridView,
            cartNotifications,
            fetchingCompanies,
            companyIds,
            hasMoreCompanies,
            hideMsrp,
            hideWholesale,
            onToggleHideMsrp,
            onToggleHideWholesale,
            showTerms,
            onSetShowTerms,
            showCustomizationDlg,
            customizationCompanyMerchantId,
            customizationProductName,
            customizationProduct2dModel,
            customizationProduct3dModel,
            entities,
            lsidIdentity,
            template,
            customizationProductIsFetching,
            customizationProduct,
            bulkCustomizationModalProduct,
            bulkCustomizationModalCustomizations,
            bulkCustomizationModalProductData,
            onCartLoad,
            showProofWarningModal,
        } = this.props;

        const { cancelledStylesCount } = this.props;

        if (document.body) {
            this.toggleClass("isMobile", viewport === "mobile" || viewport === "phablet");
            this.toggleClass("isMenuPinned", menuState === APP_MENU_STATE_PINNED);
            this.toggleClass("isTouchDevice", touchDevice);
            this.toggleClass("isSidePanelOpen", sidePanelOpen);
        }

        const viewingOnMobileApp = isMobilePage(router);
        // hack for now on the collection
        const hideNav =
            router.location.pathname.includes("/error-page") ||
            router.location.pathname.includes("/assortment") ||
            router.location.pathname.includes("/merchant") ||
            router.location.pathname.includes("/profile") ||
            router.location.pathname.includes("/drive") ||
            router.location.pathname.includes("/shipment-review") ||
            router.location.pathname.includes("/thumbnail-review") ||
            router.location.pathname.includes("/checkout/challenge") ||
            router.location.pathname.includes("/checkout/mobile") ||
            router.location.pathname.includes("/retailer-onboarding") ||
            viewingOnMobileApp;

        const hideHeader = hideNav || router.location.pathname.includes(MARKETPLACE);

        const useIntercom = this.props?.flags?.enableIntercom;
        const hideZendesk =
            router.location.pathname.includes("/profile") ||
            router.location.pathname.includes("/shipment-review") ||
            router.location.pathname.includes("/thumbnail-review") ||
            router.location.pathname.includes("/checkout/mobile") ||
            router.location.pathname.includes("/checkout/challenge") ||
            viewingOnMobileApp;

        const hideIntercom =
            router.location.pathname.includes("/profile") ||
            router.location.pathname.includes("/shipment-review") ||
            router.location.pathname.includes("/thumbnail-review") ||
            router.location.pathname.includes("/checkout/mobile") ||
            router.location.pathname.includes("/checkout/challenge") ||
            viewingOnMobileApp;

        const isRetailer = !!router.location.pathname.includes("/assortment");
        const isBrandPageOfShowSite =
            router.location.pathname.includes("/site/") &&
            router.location.pathname.includes("/page/") &&
            !router.location.pathname.includes("/brand/");
        const isBrandPage = router.location.pathname.indexOf("/brand/") === 0;
        const isSiteManagerPage =
            router.location.pathname.includes("/brand/") && router.location.pathname.includes("/sites");
        const isBrandSiteSettingPage =
            router.location.pathname.includes("/brand/") &&
            router.location.pathname.includes("/site/") &&
            router.location.pathname.includes("/settings");
        // NOTE: This is for brand page in NuORDER Marketplace
        const isBrandProfilePage = router.location.pathname.includes("/brand-profile");
        const isPageTemplate = !!router.location.query.isTemplate;
        const companyMerchantId =
            customizationCompanyMerchantId || scope.viewAs?.__merchant_id || scope.company?.__merchant_id;
        const showTermsPage =
            showTerms && isBrandPage && !viewingOnMobileApp && !router.location.pathname.includes("/profile");

        return (
            <MuiThemeProviderBase>
                <ReactQueryConfigProvider config={queryConfig}>
                    <AppProvider app={app} me={me} scope={scope}>
                        {/* <ReactQueryDevtools /> */}
                        <React.Suspense fallback={<Spinner />}>
                            <div className="wrapper" onClick={this.handleLinkClick.bind(this)} {...this.rootStyles}>
                                <div
                                    id="main-content"
                                    className={classNames("mainContent", { hideHeader, hideNav })}
                                    {...this.mainStyles}
                                    {...(touchDevice ? this.overflowForTouch : {})}
                                >
                                    {!hideNav && (
                                        <SiteNav
                                            me={me}
                                            flags={this.props.flags}
                                            activeBrand={scope.brand}
                                            viewport={viewport}
                                            touchDevice={touchDevice}
                                            onUpdateNavState={onUpdateNavState}
                                            menuState={menuState}
                                            location={location}
                                            viewportHeight={viewportHeight}
                                            scope={scope}
                                            requestsCount={requestsCount}
                                            cancelledStylesCount={cancelledStylesCount}
                                            lsidIdentity={lsidIdentity}
                                            disabled={this.state.isWOUpdating}
                                            smartOrders={this.props.smartOrders}
                                        />
                                    )}

                                    <SiteHeader
                                        onTrackShopBrandClick={onTrackShopBrandClick}
                                        activeBrand={activeBrand}
                                        activeList={activeList}
                                        cart={cart}
                                        onCartItemAdd={this.handleCartItemAdd}
                                        onCartItemRemove={onCartItemRemove}
                                        onCartBulkRemove={onCartBulkRemove}
                                        onCartItemsFetch={onCartItemsFetch}
                                        onClearCompany={onClearCompany}
                                        dragging={dragging}
                                        isFetching={isFetching}
                                        requestedConnections={requestedConnections}
                                        legacyLoaded={this.props.legacyLoaded}
                                        onClearBrand={onClearBrand}
                                        onActiveListAdd={onActiveListAdd}
                                        onActiveListFetchEntries={onActiveListFetchEntries}
                                        onActiveListRemove={onActiveListRemove}
                                        onCartFetch={onCartFetch}
                                        onCreateBuyerProfile={onCreateBuyerProfile}
                                        onRetoggleCart={onRetoggleCart}
                                        onMakeAccessRequest={onMakeAccessRequest}
                                        onSetActiveList={onSetActiveList}
                                        onSetCurrency={onSetCurrency}
                                        onSetCurrentItem={onSetCurrentItem}
                                        onSnackbarAdd={onSnackbarAdd}
                                        onGalleryReset={onGalleryReset}
                                        onSnackbarRemove={onSnackbarRemove}
                                        onSetViewAs={this.handleSetViewAs}
                                        onToggleViewAsGuest={onToggleViewAsGuest}
                                        scope={scope}
                                        sidePanelOpen={sidePanelOpen}
                                        touchDevice={touchDevice}
                                        viewAs={viewAs}
                                        viewAsGuest={viewAsGuest}
                                        viewport={viewport}
                                        schemaIds={schemaIds}
                                        schemas={schemas}
                                        hideHeader={hideHeader}
                                        cartGridView={cartGridView}
                                        cartNotifications={cartNotifications}
                                        onSyncFromCart={onSyncFromCart}
                                        onFetchStartOrderCompanies={onFetchStartOrderCompanies}
                                        companies={companies}
                                        fetchingCompanies={fetchingCompanies}
                                        companyIds={companyIds}
                                        hasMoreCompanies={hasMoreCompanies}
                                        location={location}
                                        hideMsrp={hideMsrp}
                                        onToggleHideMsrp={onToggleHideMsrp}
                                        hideWholesale={hideWholesale}
                                        onToggleHideWholesale={onToggleHideWholesale}
                                        isBrandPageOfShowSite={isBrandPageOfShowSite}
                                        isBrandPage={isBrandPage}
                                        isBrandProfilePage={isBrandProfilePage}
                                        isSiteManagerPage={isSiteManagerPage}
                                        isBrandSiteSettingPage={isBrandSiteSettingPage}
                                        isPageTemplate={isPageTemplate}
                                        viewingOnMobileApp={viewingOnMobileApp}
                                        entities={entities}
                                        onCartLoad={onCartLoad}
                                        displayInsightsToggleButton={displayInsightsToggleButton}
                                    />

                                    <main
                                        role="main"
                                        ref="main"
                                        className={classNames({
                                            sidePanelOpen:
                                                viewport !== "mobile" &&
                                                viewport !== "phablet" &&
                                                (sidePanelOpen ||
                                                    (isSideInsightsPanelEnabledAndOpen && !scope.viewAsGuest)),
                                        })}
                                    >
                                        {!showTermsPage ? (
                                            children
                                        ) : (
                                            <TermsPage
                                                router={router}
                                                brandId={scope?.brand?._id}
                                                onSetShowTerms={onSetShowTerms}
                                            />
                                        )}
                                    </main>
                                </div>
                                <Snackbars snackbars={snackbars} onClearSnackbar={onClearSnackbar} />
                                <AppLoader />
                                <LoginDialog
                                    open={loginDialogOpen}
                                    redirect={loginRedirect}
                                    onToggleDialog={this.props.onToggleLoginDialog}
                                    onRequestForgotPassword={this.props.onRequestForgotPassword}
                                    authentication={authentication}
                                    onResetState={this.props.onResetLoginState}
                                    onTrackLoginArticles={this.props.onTrackLoginArticles}
                                    onTrackLoginRegistration={this.props.onTrackLoginRegistration}
                                    onTrackLoginVideo={this.props.onTrackLoginVideo}
                                    onRedirectToForgotPassword={this.handleRedirectToForgotPassword}
                                />
                                <WorkingOrderLoadingDialog
                                    shouldShowWorkingOrder={tryOpenWorkingOrder}
                                    canStartLoadingWorkingOrder={this.props.legacyLoaded}
                                    onToggleDialog={this.props.onToggleWorkingOrderLoadingDialog}
                                    onCartLoad={onCartLoad}
                                />
                                {this.state.paymentNotification && (
                                    <Alert
                                        className="paymentAlert"
                                        open={!!this.state.paymentNotification}
                                        onRequestClose={this.handleClosePaymentNotification}
                                        title={this.state.paymentNotification.title}
                                    >
                                        <div>{this.state.paymentNotification.message}</div>
                                    </Alert>
                                )}
                                {this.state.paymentErrorNotification && (
                                    <ConfirmDialog
                                        autoScrollBodyContent={true}
                                        open={!!this.state.paymentErrorNotification}
                                        onRequestClose={this.handleClosePaymentErrorNotification}
                                        title={<ModalTitle type="failure" />}
                                        onConfirm={this.handleRedirectToFailedOrders}
                                        onCancel={this.handleClosePaymentErrorNotification}
                                        cancelLabel={Globalize.formatMessage("Close")}
                                        confirmLabel={Globalize.formatMessage("View Orders")}
                                        contentStyle={{ maxWidth: "540px" }}
                                    >
                                        <PaymentFailureContent {...this.state.paymentErrorNotification} />
                                    </ConfirmDialog>
                                )}
                                {this.state.paymentSuccessNotification && (
                                    <ConfirmDialog
                                        autoScrollBodyContent={true}
                                        open={!!this.state.paymentSuccessNotification}
                                        onRequestClose={this.handleClosePaymentSuccessNotification}
                                        title={<ModalTitle type="success" />}
                                        onConfirm={this.handleRedirectToSuccessfulOrders}
                                        onCancel={this.handleClosePaymentSuccessNotification}
                                        cancelLabel={Globalize.formatMessage("Close")}
                                        confirmLabel={Globalize.formatMessage("View Orders")}
                                        contentStyle={{ maxWidth: "540px" }}
                                    >
                                        <PaymentSuccessContent {...this.state.paymentSuccessNotification} />
                                    </ConfirmDialog>
                                )}

                                {this.state.paymentChallengeErrorNotification && (
                                    <ConfirmDialog
                                        autoScrollBodyContent={true}
                                        open={!!this.state.paymentChallengeErrorNotification}
                                        onRequestClose={this.handleClosePaymentChallengeErrorNotification}
                                        onCancel={this.handleClosePaymentChallengeErrorNotification}
                                        title={<ModalTitle type="failure" />}
                                        onConfirm={this.handleRedirectToFailedChallengedOrders}
                                        cancelLabel={Globalize.formatMessage("Close")}
                                        confirmLabel={Globalize.formatMessage("View Orders")}
                                        contentStyle={{ maxWidth: "540px" }}
                                    >
                                        <PaymentFailureContent {...this.state.paymentChallengeErrorNotification} />
                                    </ConfirmDialog>
                                )}
                                {this.state.paymentChallengeSuccessNotification && (
                                    <ConfirmDialog
                                        autoScrollBodyContent={true}
                                        open={!!this.state.paymentChallengeSuccessNotification}
                                        onRequestClose={this.handleClosePaymentChallengeSuccessNotification}
                                        onCancel={this.handleClosePaymentChallengeSuccessNotification}
                                        title={<ModalTitle type="success" />}
                                        onConfirm={this.handleRedirectToSuccessfulChallengedOrders}
                                        cancelLabel={Globalize.formatMessage("Close")}
                                        confirmLabel={Globalize.formatMessage("View Orders")}
                                        contentStyle={{ maxWidth: "540px" }}
                                    >
                                        <PaymentSuccessContent {...this.state.paymentChallengeSuccessNotification} />
                                    </ConfirmDialog>
                                )}
                                <ProofRemoveWarningModal
                                    open={showProofWarningModal}
                                    onClose={this.handleCloseProofRemoveWarning}
                                />

                                {!viewingOnMobileApp && <CheckForUpdates />}
                                {!viewingOnMobileApp && this.props.flags.paymentsInvoiceBulkActionsNu66789 && (
                                    <AsyncEventTrackerWrapperContainer router={router} />
                                )}
                                {!isRetailer && <InventoryArrivingModal />}

                                {!useIntercom && <Zendesk hide={hideZendesk} isRetailer={isRetailer} />}
                                {useIntercom && <Intercom hide={hideIntercom} scope={scope} router={router} />}

                                <WhatIsDeployed />
                                <ProductCustomizationTemplateFontLoader template={template} />
                                <ProductCustomizationModal
                                    open={!!companyMerchantId && showCustomizationDlg}
                                    onClose={this.handleCloseCustomizationModal}
                                    productName={customizationProductName}
                                    product2dModel={customizationProduct2dModel}
                                    product3dModel={customizationProduct3dModel}
                                    companyMerchantId={companyMerchantId}
                                    customizationTemplate={template}
                                    attributesValues={this.selectedCustomizationValues}
                                    defaultAttributesValues={this.defaultCustomizationValues}
                                    onAttributesChange={this.handleCustomizationSave}
                                    scope={scope}
                                    isProductFetching={customizationProductIsFetching}
                                    product={customizationProduct}
                                />
                                {bulkCustomizationModalProduct && (
                                    <BulkCustomizationModal
                                        isPDP={false}
                                        onCloseModal={this.handleCloseBulkCustomizationModal}
                                        product={bulkCustomizationModalProduct}
                                        customizations={bulkCustomizationModalCustomizations}
                                        productData={bulkCustomizationModalProductData}
                                        onApply={this.handleBulkCustomizationApply}
                                    />
                                )}
                                <CustomizationMissingCompanyWarningDialog
                                    open={!companyMerchantId && showCustomizationDlg}
                                    onClose={this.handleCloseCustomizationModal}
                                />
                                <AccessControlErrorModal />
                            </div>
                        </React.Suspense>
                    </AppProvider>
                </ReactQueryConfigProvider>
            </MuiThemeProviderBase>
        );
    }

    handleCartItemAdd = (item, rest, snackOptions) => {
        if (this.context.router.location.pathname.includes("/cart")) {
            const loaderMessage = Globalize.formatMessage("Please wait while we update your working order...");
            this.props.onShowLoader(loaderMessage);
            this.props.onAddLineItem(
                { body: { item_id: item._id } },
                { updateUI: true, notifyCart: true, quickAdd: true, loaderMessage },
            );
        } else {
            this.props.onCartItemAdd(item, rest, snackOptions);
        }
    };

    handleLegacyClick() {
        if (typeof MouseEvent === "function") {
            // The standard
            const event = new MouseEvent("click", {
                view: window,
                bubbles: true,
                cancelable: true,
            });
            document.body.dispatchEvent(event);
        } else if (document.createEvent) {
            // deprecated way, thanks IE
            const event = document.createEvent("MouseEvents");
            event.initEvent("click", true, false);
            document.body.dispatchEvent(event);
        } else if (document.createEventObject) {
            // even older IE
            document.body.fireEvent("onclick");
        }
    }

    handleLinkClick(e) {
        // Trigger global event in case someone is listening like a dropdown
        if (e.ctrlKey || e.shiftKey || e.altKey || e.metaKey || e.defaultPrevented) {
            return;
        }

        let el = e.target;
        while (el && el.nodeName !== "A") {
            el = el.parentNode;
        }
        if (!el || el.nodeName !== "A") {
            return;
        }

        // Ignore if tag has
        // 1. "download" attribute
        // 2. rel="external" attribute
        if (
            el.getAttribute("download") ||
            el.getAttribute("rel") === "external" ||
            el.getAttribute("target") === "_blank"
        ) {
            return;
        }

        const link = el.getAttribute("href");
        // ignore if empty <a>
        if (!link) {
            return;
        }

        // Check for mailto: in the href
        if (link && link.indexOf("mailto:") > -1) {
            return;
        }

        if (link && link.indexOf("javascript:void(0)") > -1) {
            return;
        }

        // Bistro
        if (link && link.indexOf("/b/") > -1) {
            return;
        }

        // If not on the same origin
        if (el.host && el.host !== window.location.host) {
            return;
        } else if (!el.host && link && link.indexOf("http") === 0 && link.indexOf(window.location.host) === -1) {
            return;
        }

        e.preventDefault();
        this.navigate(link);
    }

    navigate(page) {
        const url = page.charAt(0) === "/" ? page.slice(1) : page;
        this.context.router.push("/" + url);
    }

    loadInCartIFrame(action) {
        this.updateInCartIFrame(action);
        this.navigate(`brand/${this.props.scope.brand._id}/shipment-review?view=${action.view}`);
    }
    updateInCartIFrame(action) {
        if (action.data.gridSettings) {
            this.props.onUpdateCartGridView({
                ...transitGridSettings(action.data.gridSettings, "unpack"),
                data: action.data,
            });
        } else {
            this.props.onUpdateCartIFrame(action.data);
        }
    }
    clearCartIframe() {
        this.props.onClearCartIFrame();
    }

    handleShipmentReviewIframeMessage(data) {
        const { action, payload } = data?.payload || {};
        const { saveCustomView, dispatchReduxAction } = this.props;

        switch (action) {
            case SAVE_CUSTOM_GRID_VIEW:
                saveCustomView(payload);
                break;
            case IFRAME_REDUX_ACTION:
                dispatchReduxAction(payload);
                break;
            default:
                break;
        }
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        authentication: state.authentication,
        activeBrand: state.scope.activeBrand,
        activeList: state.activeList,
        cart: state.cart,
        dragging: state.dnd.dragging,
        isFetching: state.legacyRetailers.isFetching,
        requestedConnections: state.legacyRetailers.requestedConnections || [],
        menuState: state.app.menuState,
        legacyLoaded: state.app.legacyLoaded,
        sidePanelOpen: state.app.sidePanelOpen,
        isSideInsightsPanelEnabledAndOpen: isSideInsightsPanelEnabledAndOpenInGalleryPage(
            state,
            ownProps.router.location.pathname,
        ),
        displayInsightsToggleButton: shouldDisplayInsightsToggleButton(state, ownProps.router.location.pathname),
        snackbars: state.snackbars,
        touchDevice: state.app.touchDevice,
        viewAs: state.scope.viewAs,
        viewAsGuest: state.scope.viewAsGuest,
        viewport: state.app.viewport,
        viewportHeight: state.app.height,
        locationBeforeTransitions: state.routing.locationBeforeTransitions,
        loginDialogOpen: state.app.loginDialogOpen,
        loginRedirect: state.app.loginRedirect,
        tryOpenWorkingOrder: state.app.tryOpenWorkingOrder,
        scope: state.scope,
        schemaIds: state.schemas.result,
        schemas: state.entities.schemas,
        requestsCount: state.connectionRequests.pendingCount,
        companies: state.entities.companies,
        companyIds: state.scope.startOrderCompanies,
        fetchingCompanies: state.scope.fetchingStartOrderCompanies,
        hasMoreCompanies: state.scope.nextPageStartOrderCompanies,
        cancelledStylesCount: state.cancelledStyles.styles.count,
        hideMsrp: state.scope.hideMsrp,
        cartGridView: state.cartGridView,
        cartNotifications: state.cartNotifications,
        hideWholesale: state.scope.hideWholesale,
        showTerms: state.scope.showTerms,
        template: state.customization.current?.payload,
        showCustomizationDlg: !!state.customization.editItem.itemId,
        proofId: state.customization.editItem.proofId,
        showProofWarningModal: !!state.customization.proofWarning.itemId,
        customizationItemId: state.customization.editItem.itemId,
        customizationProductName: state.customization.editItem.productName,
        customizationProductId: state.customization.editItem.productId,
        customizationProduct: state.customization.selectedProduct.product,
        customizationProductIsFetching: state.customization.selectedProduct.isFetching,
        customizationSelectedValues: state.customization.editItem.customizations,
        customizationCompanyMerchantId: state.customization.editItem.companyMerchantId,
        customizationProduct2dModel: state.customization.editItem.__product_customizations_planar2d_model,
        customizationProduct3dModel: state.customization.editItem.__product_customizations_threedium_model,
        customizationTemplate: state.customization.current?.payload,
        entities: state.entities,
        lsidIdentity: state.lsid,
        bulkCustomizationModalProduct: state.customization.bulkCustomization.product,
        bulkCustomizationModalCustomizations: state.customization.bulkCustomization.customizations,
        bulkCustomizationModalProductData: state.customization.bulkCustomization.productDataEntries,
        smartOrders: state.smartOrders,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onSetCurrentItem: (id, force = false) => dispatch(setCurrentItem(id, force)),
        onRequestForgotPassword: ({ email, recaptchaClientKey }) =>
            dispatch(requestForgotPassword({ email, recaptchaClientKey })),
        onResetLoginState: () => dispatch(resetLoginState()),
        onActiveListAdd: (itemId) => dispatch(activeListAdd(itemId)),
        onActiveListFetchEntries: () => dispatch(activeListFetchEntries()),
        onActiveListRemove: (itemId) => dispatch(activeListRemoveAndDelete(itemId)),
        onCartFetch: (options) => dispatch(cartFetch(options)),
        onCartItemAdd: (item, params, snackOptions) => dispatch(cartItemAdd(item, params, snackOptions)),
        onAddLineItem: (item, params, snackOptions) => dispatch(addLineItem(item, params, snackOptions)),
        onCartItemRemove: (item, toast, snackOptions) => dispatch(cartItemRemove(item, toast, snackOptions)),
        onCartBulkRemove: (ids) => dispatch(cartBulkRemove(ids)),
        onCartItemsFetch: () => dispatch(cartItemsFetch()),
        onClearBrand: (brand) => dispatch(activeBrandClear(brand)),
        onClearCompany: () => dispatch(activeCompanyClear()),
        onClearSnackbar: () => dispatch(clearSnackbar()),
        onRemoveSnackbar: (id) => dispatch(removeSnackbar(id)),
        onCreateBuyerProfile: (brandInfo) => dispatch(openRetailerProfile(ownProps.router, brandInfo)),
        onMakeAccessRequest: (brandId, params) => dispatch(makeAccessRequest(brandId, params)),
        onSnackbarAdd: (params) => dispatch(snackbarAdd(params)),
        onGalleryReset: () => dispatch(resetProducts("gallery")),
        onSnackbarRemove: (id) => dispatch(snackbarRemove(id)),
        onLegacyLoaded: (isLoaded) => dispatch(legacyLoaded(isLoaded)),
        onPageLeave: () => dispatch(pageLeave()),
        onRetoggleCart: (forceRetoggle) => dispatch(cartRetoggle(forceRetoggle)),
        onSetActiveList: (catalog) => dispatch(activeListSet(catalog)),
        onSetBrand: (brand) => dispatch(activeBrandSet(brand)),
        onSetViewAsCompany: (company) => dispatch(fetchCompanyAndSetViewAs(company)),
        onSetCurrency: (currency) => dispatch(activeCurrencySet(currency)),
        onSetViewAs: (company) => dispatch(setViewAs(company)),
        onSetViewport: (viewport) => dispatch(setViewport(viewport)),
        onUpdateNavState: (state) => dispatch(updateNavState(state)),
        onToggleViewAsGuest: () => dispatch(toggleViewAsGuest()),
        onToggleWorkingOrderLoadingDialog: (isOpen) => {
            dispatch(toggleWorkingOrderLoadingDialog(isOpen));
        },
        onTrackShopBrandClick: (brandId) => dispatch(trackShopBrandClick(brandId)),
        onToggleLoginDialog: (isOpen, redirectPath) => {
            dispatch(toggleLoginDialog(isOpen, redirectPath));
        },
        onGetPendingCount: () => dispatch(getPendingCount()),
        onSyncFromCart: (order, meta) => dispatch(syncFromCart(order, meta)),
        onSaveCartEntryProint: (location) => dispatch(saveCartRedirectAfterSubmit(location)),
        onSetUserType: (accountType) => dispatch(setUserType(accountType)),
        onFetchStartOrderCompanies: (params) => dispatch(fetchStartOrderCompanies(params)),
        onGetCancelledCount: (brandId) => dispatch(getCancelledOrdersCount(brandId)),
        onGetCancelledStylesCount: (brandId) => dispatch(getCancelledStylesCount(brandId)),
        onToggleHideMsrp: (hide) => dispatch(toggleHideMsrp(hide)),
        onToggleHideWholesale: (hide) => dispatch(toggleHideWholesale(hide)),
        onTrackLoginArticles: () => dispatch(trackLoginArticles()),
        onTrackLoginRegistration: () => dispatch(trackLoginRegistration()),
        onTrackLoginVideo: () => dispatch(trackLoginVideo()),
        onSetShowTerms: (terms) => dispatch(setShowTerms(terms)),
        onResetLineItemEdit: () => dispatch(resetLineItemEdit()),
        onResetProofWarning: () => dispatch(resetProofWarning()),
        onLdFlagsChanged: (flags) => dispatch(updateLdFlags(flags)),
        onResetBulkCustomizationModal: () => dispatch(resetBulkCustomizationModal()),
        onUpdateCartIFrame: (data) => dispatch(gridActions.updateData(data)),
        onClearCartIFrame: () => dispatch(gridActions.clear()),
        onFetchProductById: (id) => dispatch(fetchCustomizationProductById(id)),
        fetchSmartOrders: () => fetchSmartOrders(dispatch),
        onUpdateCartGridView: (cartGridView) => dispatch(gridActions.update(cartGridView)),

        saveCustomView: (viewData) => dispatch(createCustomGridView(viewData)),
        dispatchReduxAction: (actionPayload) => dispatch(actionPayload),

        onCartLoad: () => dispatch(openWorkingOrder()),
        onShowLoader: (message) => dispatch(showLoader(message)),
    };
};

export default withLDConsumer()(connect(mapStateToProps, mapDispatchToProps)(Main));
